<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-21 15:00:49
-->
<template>
  <div>
    <div class="top">
      <div class="top-btn">
        <el-button
          v-if="codeData.indexOf('84') != -1"
          @click="addAdminFn"
          type="primary"
          >新增模型</el-button
        >
      </div>
      <div class="search">
        <a-select
          allowClear
          v-model:value="types"
          style="width: 418px; margin-right: 20px"
          placeholder="按模型类型筛选"
        >
          <a-select-option value="0">全站模型</a-select-option>
          <a-select-option value="1">本站模型</a-select-option>
        </a-select>
        <a-input
          v-model:value="value"
          placeholder="模型名称"
          style="width: 173px; margin-right: 20px"
        />
        <el-button @click="seacrh" type="primary">查询</el-button>
      </div>
    </div>
    <coententTable
      @handleTableChange="handleTableChange"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :pagination="pagination"
      :dataSource="dataSource"
      :customSlot="customSlot"
      :loading="loading"
       :y="height"
        @handleSizeChange="handleSizeChange"
    >
      <template v-slot:sort="scopeVal">
        <div class="sort">
          <div class="sort-box">
             <div  class="sort-two" v-if="codeData.indexOf('212') != -1"  @click="upMove(scopeVal.scope)">
                    <i   class="ri-arrow-up-line"></i>
                </div>
          </div>
          <input disabled v-model="scopeVal.scope.sort" class="sort-style" />
          <div  class="sort-box-two">
             <div  class="sort-two" v-if="codeData.indexOf('213') != -1" @click="downMove(scopeVal.scope)">
                   <i    class="ri-arrow-down-line"></i>
                </div>
          </div>
        </div>
      </template>
      <template v-slot:state="scopeVal">
         <a-switch v-if="codeData.indexOf('211') != -1" :disabled="scopeVal.scope.type == 0"  :v-model="scopeVal.scope.state" :checked="scopeVal.scope.state?false:true" @change="checked=> onChange(checked, scopeVal.scope)" />
      </template>
      <template v-slot:operation="scopeVal">
         <div style="display: flex"> 
              <div  class="btnTwo" style="margin-right: 14px;width:66px" v-if="codeData.indexOf('85') != -1" @click="field(scopeVal.scope)">字段管理</div>
              <div
              v-if="codeData.indexOf('86') != -1"
                @click="editAdmin(scopeVal.scope)"
                style="margin-right: 14px"
                class="btnTwo"
                >编辑</div
              >
              <div
                @click="open(scopeVal.scope)"
                class="btnThree"
                v-if="scopeVal.scope.type != 0 && codeData.indexOf('87') != -1"
                >删除</div
              >
              <div class="btnFour"   v-if="scopeVal.scope.type == 0 && codeData.indexOf('87') != -1">删除</div>
         </div>
      </template>
    </coententTable>
    <addCustom @closeDra="closeDra" :item="item" @close="close" :visible="visible"></addCustom>
    <el-dialog
      title="确认删除内容模型?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      :before-close="handleClose"
      custom-class="tips-box"
      top="17%"
    >
      <span>模型删除后，已用该模型生成的页面不会被删除，且能正常游览，若需再次的使用该模型，请重新添加</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="deleteFn"
          >确认删除</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import addCustom from "./add_custom_vanables.vue";
import { list,updateState,up,down,deleteOne } from "./substance_model_management";
export default {
  data() {
    return {
      visible: false,
      visibleTwo: false,
      dialogVisibleTwo: false,
      loading: false,
      types: undefined,
      height:0,
      value: "",
      columns: [
        {
          title: "模型名称",
          dataIndex: "modelName",
          ellipsis: true,
          customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "660px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "660px",
              }
          };
        }
        },
        {
          title: "模型类型",
          dataIndex: "typeName",
          ellipsis: true,
          width: 120,
        },
        {
          title: "关联模板",
          dataIndex: "templatePath",
          ellipsis: true,
          width: 200,
        },
        {
          title: "状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
          ellipsis: true,
          width: 120,
        },
        {
          title: "排序",
          dataIndex: "sort",
          scopedSlots: { customRender: "sort" },
          ellipsis: true,
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 250,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      customSlot: [
        {
          name: "state",
          customRender: "state",
        },
        {
          name: "sort",
          customRender: "sort",
        },
      ],
      item:{},
      codeData:[],
      deleteShow:false,
    };
  },
  components: {
    coententTable,
    addCustom,
  },
  mounted() {
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    upMove(item) {
        up({
          id:item.id
        }).then((res)=>{
            if(res.code == 0){
                 this.getList();
            }
        })
    },
    downMove(item) {
      down({id:item.id}).then((res)=>{
            if(res.code == 0){
                 this.getList();
            }
        })
    },
    handleTableChange(){

    },
    seacrh(){
      this.pagination.current = 1;
      this.getList();
    },
    onChange(checked,item) {
       updateState({
        id:item.id,
        state:checked?0:1,
       }).then((res)=>{
          if(res.code == 0){
              this.getList()
          }
       })
    },
    getList() {
      this.loading = true;
      list({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        types: this.types,
        name: this.value,
        siteId: sessionStorage.getItem('siteId'),
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        if(this.pagination.total > 0){
            this.height = document.documentElement.clientHeight - 400;
            window.onresize = () => {
              return (() => {
                this.height = document.documentElement.clientHeight - 400;
              })();
            };
        }
        if(this.pagination.current !=1 && this.dataSource.length == 0){
            this.pagination.current--
            this.getList()
        }
        this.loading = false;
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
       this.getList();
    },
    handleSizeChange(pageSize){
      this.pagination.current = 1;
       this.pagination.pageSize = pageSize;
       this.getList();
    },
    addAdminFn() {
       this.item = JSON.parse(JSON.stringify({}))
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.getList();
    },
    closeDra(){
      this.visible = false;
    },
    editAdmin(item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.visible = true;
    },
    open(item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.dialogVisibleTwo = true;
    },
    handleClose() {
        this.dialogVisibleTwo = false
    },
    deleteFn(){
      this.deleteShow = true;
      deleteOne({
        id:this.item.id
      }).then((res)=>{
          if(res.code == 0){
              this.dialogVisibleTwo = false;
              this.getList();
          }
          this.deleteShow = false;
      })
    },
    field(item){
      this.$router.push({
        path: "/index/configure/substance_model_management/field_management",
        query: { 
            title: "字段管理",
            islast: true,
            id:item.id,
          },
      });
    }
  },
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #E4E7ED 1px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
    width: 480px;
     /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
  }
  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.deletBox {
  background: red !important;
  .el-message-box__message {
    color: #ccc !important;
  }
}
/deep/ .el-dialog {
  font-weight: 600;
}
/deep/ .el-dialog__body {
  color: #909399;
  font-weight: 400;
}
/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
/deep/ .el-dialog__body {
  padding-top: 15px;
}
.top-btn {
  display: flex;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
  cursor: pointer;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
  cursor: pointer;
}
.sort-style {
  width: 30px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

            .el-button--primary {
  background: #176de6;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.sort-two{
   display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
</style>